(() => {
  document.querySelectorAll('[data-mercator-directory]').forEach((root) => {
    const form = root.querySelector('[data-directory-search]');
    const search = form.elements.business;
    const country = form.elements.country;
    const card = root.querySelector('[data-business-card]');
    const empty = root.querySelector('[data-directory-empty]');
    const count = root.querySelector('[data-directory-count]');
    const buttons = root.querySelectorAll('[data-directory-category]');
    const normalise = (value) => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l');
    const searchable = normalise(card.dataset.search);
    let category = 'all';
    const update = () => {
      const words = normalise(search.value).trim().split(/\s+/).filter(Boolean);
      const visible = words.every((word) => searchable.includes(word)) && ['all', 'bulgaria'].includes(country.value) && ['all', 'uniforms', 'embroidery', 'hospitality', 'studio'].includes(category);
      card.hidden = !visible;
      empty.hidden = visible;
      count.textContent = visible ? count.dataset.one : count.dataset.zero;
    };
    form.addEventListener('submit', (event) => { event.preventDefault(); update(); });
    search.addEventListener('input', update);
    country.addEventListener('change', update);
    buttons.forEach((button) => button.addEventListener('click', () => {
      category = button.dataset.directoryCategory;
      buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      update();
    }));
    root.querySelector('[data-directory-reset]').addEventListener('click', () => {
      form.reset(); category = 'all';
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.directoryCategory === 'all')));
      update(); search.focus();
    });
  });
})();
